import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { FormControl, NgForm, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Account, ClientData } from "../user-profile-details/client-data";
import Swal from "sweetalert2";
import { ApiService } from "src/app/services/api.service";
import { HttpClient } from "@angular/common/http";
import { UrlConstants } from "src/app/models/urlConstants";
import {
  ApexChart,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexTheme,
} from "ng-apexcharts";
import {
  BroadcastEventListener,
  ISignalRConnection,
  SignalR,
  SignalRConfiguration,
} from "ng2-signalr";
import { RequestService } from "src/app/services/request.service";
import { Router } from "@angular/router";
import { SystemSettingsService } from "src/app/services/systemSettings.service";

interface T0Request {
  RelationCode: string;
  Body: string;
  RelationClientCode: string;
  CurrencyId: number;
  Amount: number | null;
  IsMaxAmount: boolean;
}
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  theme: ApexTheme;
};
@Component({
  selector: "app-request-t0-modal",
  templateUrl: "./request-t0-modal.component.html",
  styleUrls: ["./request-t0-modal.component.scss"],
})
export class RequestT0ModalComponent implements OnInit {
  isMaxAmount: boolean = false;
  amount: number = 0;
  isSubmitting = false;
  @Input() selectedAccount: Account;
  titleMessage: string;
  textConfirmMassage: string;
  submitStatus;
  Endorsement: string;
  newReqT0: T0Request = {} as T0Request;
  showTradesSummary: boolean = false;
  refresh: boolean = false;
  noChart: boolean;
  isProfileLoading = false;
  userPortfolio: ClientData;
  companyName: string;
  chartStocks: number;
  purchaseStocks: number;
  public chartOptions: Partial<ChartOptions>;
  private portfolioConnection: ISignalRConnection;
  accList: Account[];
  lastExecutionTime: number = 0;
  userAccounts: Account[];
  selectedAccountControl = new FormControl(null, Validators.required);
  accountList: Account[];
  currencyList: any[] = [];
  selectedCurrency: any;

  constructor(
    public translate: TranslateService,
    private apiService: ApiService,
    private http: HttpClient,
    private signalR: SignalR,
    private requestService: RequestService,
    private router: Router,
    private systemSettingsService: SystemSettingsService
  ) {}

  ngOnInit(): void {
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
    this.requestService.fetchActiveCurrencies().subscribe((res) => {
      this.currencyList = res;
      this.selectedCurrency = this.currencyList[0];
    });
    this.getCompanyName();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }

    getCompanyName() {
    const companyNameLang = this.translate.currentLang == "en" ? "English Company Name":"Arabic Company Name";
    this.systemSettingsService.checkCompanyName(companyNameLang).subscribe((res) => {
      if (res) {
        this.companyName = res.value;
        this.Endorsement = `الساده شركة ${this.companyName} برجاء التكرم بفتح حد إئتمان للتداول في ذات الجلسة علي حسابي طرف شركتكم  وفي حالة التنفيذ و ظهور مديونية أتعهد أن يتم سداد كامل مديونية اليوم بالبيع أو بالإيداع و في حالة عدم التزامي بإغلاق المديونية قبل نهاية الجلسة بنصف ساعة أفوض الشركة ببيع أي أسهم موجودة بمحفظتي لسداد كامل المديونية وهذا إقرار مني بذلك`;

      }
    })
  }

  onAccountChange(relationCode: string) {
    if (!this.userAccounts) {
      return;
    }
    const selectedAcc = this.userAccounts.find(
      (acc) => acc.relationCode === relationCode
    );
    if (selectedAcc) {
      this.selectedAccount = selectedAcc;
      //this.fetchUserPortfolio(selectedAcc);
    }
  }

  withMaxLimit()
  {
this.isMaxAmount = !this.isMaxAmount;
  }

  fetchUserPortfolio(selectedAcc?) {
    this.showTradesSummary = true;
    if (selectedAcc) this.selectedAccount = selectedAcc;

    this.refresh = !this.refresh;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.noChart = null;
      this.isProfileLoading = true;

      this.requestService
        .fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.isProfileLoading = false;
          this.userPortfolio = res as ClientData;
          if (
            this.ratedActiveBalance == 0 &&
            this.userPortfolio.Portfolio.RatedPortfolio == null
          )
            this.noChart = true;
          else if (
            this.ratedActiveBalance > 0 &&
            (!this.userPortfolio?.Portfolio?.RatedPortfolio ||
              this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue ==
                0)
          ) {
            this.purchaseStocks = 100;
            this.chartStocks = 0;
            this.initChart();
          } else if (
            this.ratedActiveBalance <= 0 &&
            this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue > 0
          ) {
            this.purchaseStocks = 0;
            this.chartStocks = 100;
            this.initChart();
          } else if (this.userPortfolio?.Portfolio?.RatedPortfolio != null) {
            this.chartStocks =
              (this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue /
                (this.userPortfolio?.Portfolio?.RatedPortfolio
                  ?.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
            this.purchaseStocks =
              (this.ratedActiveBalance /
                (this.userPortfolio?.Portfolio?.RatedPortfolio
                  ?.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
            this.initChart();
          }
          // if (this.userPortfolio.Portfolio.RatedPortfolio) {
          //   this.chartStocks =
          //     (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
          //       (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
          //         this.ratedActiveBalance)) *
          //     100;
          //   this.purchaseStocks =
          //     (this.ratedActiveBalance /
          //       (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
          //         this.ratedActiveBalance)) *
          //     100;
          //   this.initChart();
          // } else if (this.ratedActiveBalance) {
          //   this.purchaseStocks = 100;
          //   this.chartStocks = 0;
          //   this.initChart();
          // }
        });

      this.clientSelected(this.selectedAccount);
    }
  }
  clientSelected(e: Account) {
    // this.apiService.fetchClientAccounts(e.relationCode).subscribe((res) => {
    //   this.userAccounts = res as Account[];
    //   this.accList = res as Account[];
    //   this.initPortfolioSignalR();
    //   this.selectedAccountControl.setValue(null);
    // });
    this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccountControl.setValue(null);
    this.initPortfolioSignalR();

  }

  initPortfolioSignalR() {
    if (this.portfolioConnection != null) this.portfolioConnection.stop();

    if (this.selectedAccount.ExchangeCode != null) {
      let config: SignalRConfiguration = new SignalRConfiguration();
      config.url = UrlConstants.backofficeUrl;
      config.hubName = "ordersHub";
      config.logging = false;

      this.signalR.connect(config).then((res) => {
        this.portfolioConnection = res;

        this.portfolioConnection.invoke(
          "JoinGroup",
          this.selectedAccount.ExchangeCode
        );

        let method = new BroadcastEventListener<any>("UpdatePortfolio");

        this.portfolioConnection.listen(method);
        method.subscribe((update) => {
          this.refetchClientInfo();
        });

        this.portfolioConnection.errors.subscribe((res) => {
          this.initPortfolioSignalR();
        });
      });
    }
  }

  refetchClientInfo() {
    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      const currentTime = Date.now();
      const timeElapsed = currentTime - this.lastExecutionTime;

      if (timeElapsed < 5000) {
        return;
      }

      // Update the last execution time
      this.lastExecutionTime = currentTime;

      this.noChart = null;
      this.isProfileLoading = true;

      this.http
        .get(
          `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount.relationCode}`
        )
        .subscribe((res) => {
          this.isProfileLoading = false;
          this.userPortfolio = res as ClientData;
          if (
            this.ratedActiveBalance == 0 &&
            this.userPortfolio.Portfolio.RatedPortfolio == null
          )
            this.noChart = true;
          else if (
            this.ratedActiveBalance > 0 &&
            (!this.userPortfolio.Portfolio?.RatedPortfolio ||
              this.userPortfolio.Portfolio?.RatedPortfolio?.TotalMarketValue ==
                0)
          ) {
            this.purchaseStocks = 100;
            this.chartStocks = 0;
            this.initChart();
          } else if (
            this.ratedActiveBalance <= 0 &&
            this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue > 0
          ) {
            this.purchaseStocks = 0;
            this.chartStocks = 100;
            this.initChart();
          } else if (this.userPortfolio.Portfolio.RatedPortfolio != null) {
            this.chartStocks =
              (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
            this.purchaseStocks =
              (this.ratedActiveBalance /
                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
            this.initChart();
          }
        });
    } else this.portfolioConnection.stop();
  }
  get ratedActiveBalance() {
    return this.userPortfolio?.PurchasePower?.BlockingAmount?.find(
      (item) => item.curr == "Rated"
    ).activebalance;
  }

  initChart() {
    this.chartOptions = {
      series: [this.chartStocks, this.purchaseStocks],
      chart: {
        width: "100%",
        height: "295",
        type: "donut",
      },
      theme: {
        mode: "light",
        palette: "palette7",
      },
      labels: [
        this.translate.instant("stocks"),
        this.translate.instant("cash"),
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };
  }
  submitReqT0(form: NgForm) {
    if (form && form.valid) {
      if((!this.isMaxAmount && this.amount >0)|| this.isMaxAmount ){
      this.newReqT0.RelationCode = this.selectedAccount.relationCode;
      this.newReqT0.Body = this.Endorsement;
      this.newReqT0.Amount = this.isMaxAmount ? null : this.amount;
      this.newReqT0.IsMaxAmount = this.isMaxAmount;
      this.newReqT0.CurrencyId = this.selectedCurrency?.CurrencyID;
if (this.translate.currentLang === "ar") {
  this.titleMessage = "تأكيد طلب (T+0)";
this.textConfirmMassage = `
  الحساب: ${this.selectedAccount.clientNameAr}
  كود العميل : ${this.selectedAccount.relationCode}
  ${this.isMaxAmount? 'الحد الاقصي': 'بقيمة نقدية'  }
  ${!this.isMaxAmount ? `المبلغ النقدى : ${this.amount}<br/>العملة : ${this.translate.currentLang == 'ar'? this.selectedCurrency?.CurrencyNameA: this.selectedCurrency.CurrencyNameE}` : ""}
  <div style="width: 300px; white-space: normal; margin: auto;">${this.Endorsement}</div>
`;

}

if (this.translate.currentLang === "en") {
  this.titleMessage = "T+0 Request Confirmation";
this.textConfirmMassage = `
  Account: ${this.selectedAccount.clientNameEn}
  Client Code: ${this.selectedAccount.relationCode}
  ${this.isMaxAmount? 'Max Limit':'Limited' }
  ${!this.isMaxAmount ? `Amount: ${this.amount}<br/>Currency : ${this.translate.currentLang == 'en'? this.selectedCurrency?.CurrencyNameE: this.selectedCurrency.CurrencyNameA}` : ""}
  <div style="width: 300px; white-space: normal; margin: auto;">${this.Endorsement}</div>
`;
}
      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.fetchTPlusZero(this.newReqT0).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            }
          );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
    }
  }
}
